import { createSelector } from 'reselect'
import * as R from 'ramda'
import { getResources } from 'store/reducers/resources'
import { isTypeProduct } from 'domain/resources'
import { isAllProductsPathname } from 'domain/router'
import { getAllProductsResource } from './allProducts'
import { getSaleKey } from './application'
import {
  getQueryKeyParam,
  getUri
} from './router'
import {
  GetCurrentResource,
  GetCurrentResourceCities,
  GetCurrentResourceDeparturesDates,
  GetCurrentResourceDurations,
  GetResourceHasProducts
} from './currentResource.types'

export const getCurrentResource: GetCurrentResource = createSelector(
  getUri,
  getQueryKeyParam,
  getSaleKey,
  getResources,
  getAllProductsResource,
  (uri, key, saleKey, resources, allProductsResource) => R.cond([
    [R.always(isAllProductsPathname(uri)), R.always(allProductsResource)],
    [R.isNil, R.always(undefined)],
    [R.T, R.cond([
      [R.has(key), R.prop(key)],
      [R.T, R.prop(saleKey)]
    ])]
  ])(resources)
)

export const getResourceHasProducts: GetResourceHasProducts = createSelector(
  getCurrentResource,
  getResources,
  (currentResource, allResources) => R.ifElse(
    R.isNil,
    R.always(false),
    R.compose(
      R.any(R.compose(
        isTypeProduct,
        R.prop(R.__, allResources)
      )),
      R.prop('resources')
    )
  )(currentResource)
)

export const getCurrentResourceCities: GetCurrentResourceCities = createSelector(
  getCurrentResource,
  R.path(['ecomm', 'cities'])
)

export const getCurrentResourceDeparturesDates: GetCurrentResourceDeparturesDates = createSelector(
  getCurrentResource,
  R.path(['ecomm', 'departuresDates'])
)

export const getCurrentResourceDurations: GetCurrentResourceDurations = createSelector(
  getCurrentResource,
  R.path(['ecomm', 'durations'])
)
